function Pin({ style }) {
  const { fill = '#63637B', width = 32, height = 32 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke={fill}
        strokeLinecap="square"
        strokeWidth="2"
        d="M23.999 12.308c0 4.587-8 15.692-8 15.692s-8-11.105-8-15.692c0-4.588 3.582-8.308 8-8.308s8 3.72 8 8.308Z"
      />
      <path
        stroke={fill}
        strokeLinecap="square"
        strokeWidth="2"
        d="M15.997 9.457c-.611 0-1.198.252-1.63.701a2.443 2.443 0 0 0-.676 1.694c0 .635.243 1.244.676 1.693a2.264 2.264 0 0 0 1.63.701c.612 0 1.199-.252 1.631-.7.433-.45.675-1.06.675-1.694 0-.635-.242-1.245-.675-1.694a2.264 2.264 0 0 0-1.63-.701v0Z"
      />
    </svg>
  );
}

export default Pin;
